import React from "react";
import { Link as PGLINK } from "react-router-dom";
import "./refundPage.css";

const RefundPageBody = () => {
  return (
    <>
      <PGLINK
        to="/"
        className="nav-item"
        style={{
          border: "1px solid black",
          position: "absolute",
          top: "1rem",
          width: "fit-content",
          left: "1rem",
          padding: "0.5rem",
        }}
      >
        Home
      </PGLINK>
      <section className="refundPage-container">
        <h1>Cancellation and Refund Policy</h1>
        <p>
          <i>ValsCo Technology Pvt Ltd - Courses and Services</i>
        </p>
        <section className="points">
          <h2>Cancellation Period:</h2>
          <p>
            Customers may cancel their course or service registration within 24
            hours of payment, provided that the course/service has not yet
            commenced or been delivered.
          </p>
        </section>
        <section className="points">
          <h2>Cancellation Fees</h2>
          <p>
            No cancellation fees will be charged if the cancellation request is
            made within the specified period above.
          </p>
          <p>
            If the course/service has already commenced or been delivered (in
            part or in full), cancellation fees may apply.
          </p>
        </section>
        <section className="points">
          <h2>Refund Policy:</h2>
          <p>
            If the registration/service is canceled within the cancellation
            period, the customer will receive a full refund to their original
            method of payment.
          </p>
          <p>
            If the registration/service is canceled after the cancellation
            period but before commencement, a refund may be issued, subject to
            deduction of any applicable cancellation fee.
          </p>
          <p>
            Once the course/service has commenced or been delivered, no refunds
            will be provided.
          </p>
        </section>
        <section className="points">
          <h2>Refund Process Timeframe:</h2>
          <p>
            All approved refunds will be processed within 7–10 business days
            from the date of cancellation confirmation.
          </p>
        </section>
        <section className="points">
          <h2>Refund Credit Timeframe</h2>
          <p>
            After processing, the refund will be credited to the customer’s
            original payment method within 5–7 business days, depending on the
            customer’s bank/payment provider.
          </p>
        </section>
        <section className="points">
          <h2>Process for Cancellation:</h2>
          <p>
            To request cancellation, customers must contact our support team via
            email at{" "}
            <a className="text-blue-700" href="mailto:connect@valscotech.com">
              connect@valscotech.com.
            </a>{" "}
          </p>
          <p>
            Our customer support team is available Monday to Friday, 9 am to 5
            pm.
          </p>
        </section>
        <section className="points">
          <h2>Unforeseen Circumstances:</h2>
          <p>
            ValsCo Technology Pvt Ltd reserves the right to cancel, postpone, or
            delay any course or service due to unforeseen circumstances beyond
            our control, such as technical issues, trainer unavailability, or
            force majeure events.
          </p>
        </section>
        <section className="points">
          <h2>Legal Compliance:</h2>
          <p>
            This policy complies with all applicable local, state, and federal
            laws governing cancellations and refunds for online educational and
            technology services.
          </p>
        </section>
        <section className="points">
          <h2>Terms Changes:</h2>
          <p>
            ValsCo Technology Pvt Ltd reserves the right to modify this
            Cancellation and Refund Policy at any time without prior notice.
          </p>
          <p>
            Any updates will be communicated via email to registered customers.
          </p>
        </section>
        <section className="points">
          <h2>Contact Information:</h2>
          <p>
            For inquiries or assistance with cancellations and refunds, please
            reach out to us at{" "}
            <a className="text-blue-700" href="mailto:connect@valscotech.com">
              connect@valscotech.com
            </a>{" "}
            (Monday to Friday, 9 am to 5 pm).
          </p>
        </section>
        <section className="points">
          <h2>Arbitration:</h2>
          <p>
            Any disputes arising out of or related to this policy shall be
            resolved through arbitration in accordance with the laws of India.
          </p>
        </section>
      </section>
    </>
  );
};

export default RefundPageBody;
